export default [{
  asunto: "Observacion 1",
  nombre: "qweweqwe",
  responsable: ["Jhonatan Mejia"],
  created_at: "2015-04-24T01:46:50.459583",
  updated_at: "2015-04-24T01:46:50.459593",
  email: "a@mail.es",
  id: 245
}, {
  asunto: "Solicitud observacion",
  nombre: "asdasdasd",
  responsable: ["Vanesa"],
  created_at: "2015-04-24T01:46:50.457459",
  updated_at: "2015-04-24T01:46:50.457468",
  email: "sistemas3@mejoraysoluciones.com",
  id: 244
}]
